.alert {
  padding: var(--rc-theme-spacing-ms);
  border-radius: var(--rc-theme-border-radius-base);

  &.alert--neutral {
    border-color: var(--rc-theme-color-text-default);
    background-color: var(--rc-theme-color-surface-subtle);

    :global(.ant-alert-icon) {
      color: var(--rc-theme-color-text-default);
    }
  }
}

.banner-wrapper {
  border-width: 0 0 1px;
  border-style: solid;

  /* TODO: banner title should have line-height 20px when font-size is 12px */
  .alert--banner {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--rc-theme-spacing-xxxs) var(--rc-theme-spacing-xs);
    border-radius: 0;

    .alert--section {
      max-width: fit-content;
    }
  }

  &.banner-border-success {
    border-bottom-color: var(--rc-theme-color-success-default);
  }

  &.banner-border-info {
    border-bottom-color: var(--rc-theme-color-info-default);
  }

  &.banner-border-warning {
    border-bottom-color: var(--rc-theme-color-warning-default);
  }

  &.banner-border-error {
    border-bottom-color: var(--rc-theme-color-error-default);
  }

  &.banner-border-neutral {
    border-bottom-color: var(--rc-theme-color-text-default);
  }
}
